import axios from "axios"
import { Fragment, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { ErrorModal } from "."

const ResetPasswordForm = () => {
    const [form, setForm] = useState({ name: '', password: ''})
    const [errors, setErrors] = useState({})

    const [errorMessage, setErrorMessage] = useState()
    const [showErrorModal, setShowErrorModal] = useState(false)

    const handleShowErrorModal = () => setShowErrorModal(!showErrorModal)

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
          // Check and see if errors exist, and remove them from the error object:
        if ( !!errors[field] ) setErrors({
            ...errors,
            [field]: null
        })
    }

    const findFormErrors = () => {
        const { password } = form
        const newErrors = {}

        // password error
        if (password.length < 8) newErrors.password = 'Password length must be more than 8!'
    
        return newErrors
    }
    
    const resetPassword = (form) => {
        const url = '../../change_pass.php'
        axios.post(url, { 
            name: form.name,
            password: form.password
        }, { 
            headers: { 'content-type': 'application/json' }
        })
        .then(result => {
            const nullError = (result.data === undefined || result.data === null || result.data === "")
            const userNotFoundException = result.data.includes("UserNotFoundException")
            const message = nullError ? "Server is under maintenance or not available now." : userNotFoundException ? "User is not found! Please enter the correct user ID." : "Password has been successfully changed!"
            setErrorMessage(message)
            setShowErrorModal(!showErrorModal)
        })
        .catch(error => { 
            if (error.toJSON().message === 'Network Error') {
                alert('Please check your internet connection!');
            } else {
                console.log(error)
            }
        });
    }

    const onSubmit = (e) => {
        e.preventDefault();

        const newErrors = form && findFormErrors();
        // Conditional logic:
        if (Object.keys(newErrors).length > 0) {
          // We got errors!
            setErrors(newErrors)
        } else {
          // No errors! Put any logic here for the form submission!
            resetPassword(form)
            setForm({ name: "", password: "" })
        }
    };
    
    return (
        <Fragment>
            <Form style={{margin: '20px 50px'}} onSubmit={onSubmit}>
                <h4 className='mt-5 mb-4 fw-bold'>Reset User Password</h4>
                <Form.Group as={Row} className='mb-3'>
                    <Form.Label className='fw-bold' column sm='4'>
                        Username
                    </Form.Label>
                    <Col sm='6'>
                        <Form.Control 
                            type='text'
                            name='name'
                            placeholder='Enter Username'
                            value={form.name}
                            onChange={(e) => setField('name', e.target.value)}
                            isInvalid={ !!errors.name }
                            required 
                        />
                        <Form.Control.Feedback type='invalid'>
                            { errors.name }
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className='mb-3'>
                    <Form.Label className='fw-bold' column sm='4'>
                        Password (8 digit)
                    </Form.Label>
                    <Col sm='6'>
                        <Form.Control 
                            type='password' 
                            name='password'
                            placeholder='Enter New Password: XXXXXXXX'
                            value={form.password}
                            onChange={(e) => setField('password', e.target.value)}
                            isInvalid={ !!errors.password }
                            required 
                        />
                        <Form.Control.Feedback type='invalid'>
                            { errors.password }
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>
                <Button as="input" type="submit" value="Submit" />
            </Form>
            {
                showErrorModal && 
                <ErrorModal message={errorMessage} show={showErrorModal} handleClose={handleShowErrorModal} />
            }
        </Fragment>
    )
}

export default ResetPasswordForm
